/* ============================================================
   artvision® · ART FINDER · Wizard
   Figma 500:3 ff.

   Der Wizard ist eine Fläche, die sich über die Seite legt.
   Er hält die Antworten in sessionStorage und übergibt sie am
   Ende als Query an die Ergebnisseite — damit ist der Stand
   teilbar und übersteht einen Reload.

   Antwortformat (sessionStorage 'av:finder:v1'):
     { style: ['abstrakt'], color: ['warm'], context: 'privat',
       room: ['wohnbereich'], mood: ['ruhig'], format: 'mittel',
       budget: '1000-2500', focus: ['unikat'], wall: '240' }

   Liste oder Einzelwert richtet sich nach 'Mehrfach' in
   snippets/av-finder-data.liquid — Raum, Wirkung und Schwerpunkt
   sind Mehrfachauswahl, Kontext, Präsenz und Budget nicht.

   Der Wert '*' heißt "keine Einschränkung" und wird beim Bauen
   der Query weggelassen — nicht als Filter gesetzt.
   ============================================================ */

(function () {
  'use strict';

  var STORE_KEY = 'av:finder:v1';
  var OPEN_CLASS = 'av-fnd-is-open';
  var ANY = '*';

  /* Die Gruppe, die andere Gruppen desselben Schirms steuert.
     Heute ist das nur "privat oder gewerblich" im Schritt Raum &
     Wirkung — siehe applyContext weiter unten. */
  var CONTEXT_GROUP = 'context';

  var root = document.querySelector('[data-av-finder]');
  if (!root) return;

  var screens = Array.prototype.slice
    .call(root.querySelectorAll('.av-fnd-wz__screen[data-screen]'))
    .filter(function (el) {
      return el.getAttribute('data-screen').indexOf('__') !== 0;
    });

  if (!screens.length) return;

  var doneScreen = root.querySelector('[data-screen="__done"]');
  var foot = root.querySelector('[data-av-finder-foot]');
  var elCount = root.querySelector('[data-av-finder-count]');
  var elProgress = root.querySelector('[data-av-finder-progress]');
  var btnBack = root.querySelector('[data-av-finder-back]');
  var btnSkip = root.querySelector('[data-av-finder-skip]');
  var btnNext = root.querySelector('[data-av-finder-next]');
  var resultUrl = root.getAttribute('data-result-url') || '/pages/art-finder-auswahl';

  var total = screens.length;
  var index = 0;
  var opener = null;
  var answers = load();

  /* ---------- Zustand ------------------------------------- */

  function load() {
    try {
      var raw = window.sessionStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function save() {
    try {
      window.sessionStorage.setItem(STORE_KEY, JSON.stringify(answers));
    } catch (e) {
      /* Privater Modus: der Wizard läuft trotzdem, nur ohne Gedächtnis. */
    }
  }

  function groupsOf(screen) {
    return Array.prototype.slice.call(screen.querySelectorAll('[data-group]'));
  }

  function isMulti(group) {
    return group.getAttribute('data-multi') === '1';
  }

  /* ---------- Auswahl ------------------------------------- */

  function valuesFor(key, multi) {
    var v = answers[key];
    if (multi) return Array.isArray(v) ? v : v ? [v] : [];
    return v ? [String(v)] : [];
  }

  function paint(group) {
    var key = group.getAttribute('data-group');
    var selected = valuesFor(key, isMulti(group));

    Array.prototype.forEach.call(group.querySelectorAll('.av-fnd-opt'), function (btn) {
      var on = selected.indexOf(btn.getAttribute('data-value')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('av-is-selected', on);
    });
  }

  function choose(group, value) {
    var key = group.getAttribute('data-group');
    var multi = isMulti(group);

    if (!multi) {
      answers[key] = answers[key] === value ? '' : value;
    } else {
      var list = valuesFor(key, true);
      var at = list.indexOf(value);

      if (at !== -1) {
        list.splice(at, 1);
      } else if (value === ANY) {
        /* "Ich bin offen" schließt jede andere Wahl aus. */
        list = [ANY];
      } else {
        list = list.filter(function (v) {
          return v !== ANY;
        });
        list.push(value);
      }

      answers[key] = list;
    }

    paint(group);
    save();

    /* Die Kontextantwort entscheidet, welche Optionen der anderen
       Gruppen auf diesem Schirm überhaupt zur Wahl stehen. */
    if (key === CONTEXT_GROUP) {
      var screen = group.closest('.av-fnd-wz__screen');
      if (screen) applyContext(screen);
    }
  }

  /* ---------- Kontext: privat oder gewerblich --------------- */

  /* Eine Option kann an einen Kontext gebunden sein
     (data-context="privat"). Sie steht zur Wahl, solange die
     Gruppe 'context' nichts, '*' oder genau diesen Wert trägt.
     So blendet die Frage "privat oder gewerblich" die Bereiche
     aus, die nicht dazu passen — der Schritt bleibt einer, und
     der Wizard bleibt bei sechs Schritten.

     Solange nichts gewählt ist, steht alles zur Wahl. Das ist
     Absicht: der Schritt ist überspringbar, und wer ihn
     überspringt, soll nicht auf einen halben Raumsatz schauen. */

  function contextValue() {
    var v = answers[CONTEXT_GROUP];
    if (Array.isArray(v)) v = v[0];
    return String(v || '').trim();
  }

  function applyContext(screen) {
    var ctx = contextValue();
    var open = !ctx || ctx === ANY;

    groupsOf(screen).forEach(function (group) {
      var key = group.getAttribute('data-group');
      if (key === CONTEXT_GROUP) return;

      var multi = isMulti(group);
      var dropped = false;

      Array.prototype.forEach.call(group.querySelectorAll('.av-fnd-opt'), function (btn) {
        var want = btn.getAttribute('data-context');
        var visible = !want || open || want === ctx;

        btn.hidden = !visible;

        /* Eine verdeckte Antwort darf nicht weiterfiltern — sonst
           sucht jemand nach "privat" und bekommt still das Ergebnis
           für eine Kanzlei. */
        if (!visible && btn.classList.contains('av-is-selected')) {
          var value = btn.getAttribute('data-value');

          if (multi) {
            answers[key] = valuesFor(key, true).filter(function (v) {
              return v !== value;
            });
          } else {
            answers[key] = '';
          }

          dropped = true;
        }
      });

      if (dropped) {
        paint(group);
        save();
      }
    });
  }

  function clearScreen(screen) {
    groupsOf(screen).forEach(function (group) {
      answers[group.getAttribute('data-group')] = isMulti(group) ? [] : '';
      paint(group);
    });

    var field = screen.querySelector('[data-av-finder-field]');
    if (field) {
      answers[field.getAttribute('data-av-finder-field')] = '';
      field.value = '';
    }

    save();

    /* Mit der Kontextantwort ist auch die Einschränkung weg. */
    applyContext(screen);
  }

  /* ---------- Navigation ---------------------------------- */

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function show(i) {
    index = Math.max(0, Math.min(total - 1, i));

    screens.forEach(function (screen, n) {
      screen.hidden = n !== index;
    });
    if (doneScreen) doneScreen.hidden = true;
    if (foot) foot.hidden = false;

    var current = screens[index];
    groupsOf(current).forEach(paint);
    applyContext(current);

    var field = current.querySelector('[data-av-finder-field]');
    if (field) field.value = answers[field.getAttribute('data-av-finder-field')] || '';

    if (elCount) elCount.textContent = pad(index + 1) + ' / ' + pad(total);
    if (elProgress) elProgress.style.width = ((index + 1) / total) * 100 + '%';
    if (btnSkip) btnSkip.hidden = current.getAttribute('data-skip') !== '1';

    root.scrollTop = 0;

    var first = current.querySelector('.av-fnd-opt:not([hidden])');
    if (first) first.focus({ preventScroll: true });
  }

  function next() {
    if (index >= total - 1) return finish();
    show(index + 1);
  }

  function back() {
    if (index === 0) return close();
    show(index - 1);
  }

  function skip() {
    clearScreen(screens[index]);
    next();
  }

  /* ---------- Abschluss ----------------------------------- */

  function query() {
    var parts = [];

    Object.keys(answers).forEach(function (key) {
      var value = answers[key];

      if (Array.isArray(value)) {
        value = value.filter(function (v) {
          return v && v !== ANY;
        });
        if (!value.length) return;
        value = value.join(',');
      }

      value = String(value || '').trim();
      if (!value || value === ANY) return;

      parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });

    return parts.join('&');
  }

  function finish() {
    save();

    screens.forEach(function (screen) {
      screen.hidden = true;
    });
    if (doneScreen) doneScreen.hidden = false;
    if (foot) foot.hidden = true;
    if (elCount) elCount.textContent = '';
    if (elProgress) elProgress.style.width = '100%';

    var q = query();
    var target = resultUrl + (q ? (resultUrl.indexOf('?') === -1 ? '?' : '&') + q : '');
    var quick = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.setTimeout(function () {
      window.location.assign(target);
    }, quick ? 250 : 1100);
  }

  /* ---------- Öffnen und Schließen ------------------------ */

  function open(trigger) {
    if (!root.hidden) return;

    opener = trigger || null;
    answers = load();
    root.hidden = false;
    document.documentElement.classList.add(OPEN_CLASS);

    /* Ein History-Eintrag, damit der Zurück-Button den Wizard
       schließt statt die Seite zu verlassen. */
    try {
      window.history.pushState({ avFinder: true }, '', window.location.href);
    } catch (e) {
      /* ohne History-Eintrag schließt nur Escape und Abbrechen */
    }

    show(0);
  }

  function close() {
    if (root.hidden) return;

    root.hidden = true;
    document.documentElement.classList.remove(OPEN_CLASS);

    if (window.history.state && window.history.state.avFinder) {
      try {
        window.history.back();
      } catch (e) {
        /* ignorieren */
      }
    }

    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }

  /* ---------- Tastatur ------------------------------------ */

  function trap(event) {
    if (event.key !== 'Tab') return;

    var focusable = root.querySelectorAll(
      'button:not([hidden]):not([disabled]), input, a[href]'
    );
    var list = Array.prototype.filter.call(focusable, function (el) {
      return el.offsetParent !== null;
    });
    if (!list.length) return;

    var first = list[0];
    var last = list[list.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---------- Verdrahtung --------------------------------- */

  document.addEventListener('click', function (event) {
    var start = event.target.closest('[data-av-finder-start]');
    if (!start) return;
    event.preventDefault();
    open(start);
  });

  root.addEventListener('click', function (event) {
    var option = event.target.closest('.av-fnd-opt');
    if (option) {
      var group = option.closest('[data-group]');
      if (group) choose(group, option.getAttribute('data-value'));
      return;
    }

    if (event.target.closest('[data-av-finder-cancel]')) return close();
    if (event.target.closest('[data-av-finder-back]')) return back();
    if (event.target.closest('[data-av-finder-skip]')) return skip();
    if (event.target.closest('[data-av-finder-next]')) return next();
  });

  root.addEventListener('input', function (event) {
    var field = event.target.closest('[data-av-finder-field]');
    if (!field) return;
    answers[field.getAttribute('data-av-finder-field')] = field.value.trim();
    save();
  });

  root.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    trap(event);
  });

  window.addEventListener('popstate', function () {
    if (!root.hidden) {
      root.hidden = true;
      document.documentElement.classList.remove(OPEN_CLASS);
      opener = null;
    }
  });

  /* Direkteinstieg von außen: /pages/art-finder?finder=start */
  if (/[?&]finder=start\b/.test(window.location.search) || window.location.hash === '#art-finder') {
    open(null);
  }
})();
